import React from "react";
import { FaChevronDown } from "react-icons/fa";

/**
 * Collapsible section header with primary accent border.
 * @param {{ title: string, isExpanded: boolean, onToggle: () => void }} props
 */
const SectionHeader = ({ title, isExpanded, onToggle }) => (
  <div
    className="d-flex justify-content-between align-items-center mb-2"
    onClick={onToggle}
    style={{ cursor: "pointer", userSelect: "none", padding: "4px 0" }}
  >
    <div
      className="d-flex align-items-center"
      style={{ borderLeft: "4px solid var(--primary, #00a99d)", paddingLeft: "10px" }}
    >
      <span
        className="text-primary"
        style={{ fontSize: "14px", fontWeight: "bold", color: "var(--primary, #00a99d)" }}
      >
        {title}
      </span>
    </div>
    <span
      style={{
        transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
        transition: "transform 0.25s ease",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <FaChevronDown style={{ fontSize: "12px", color: "#8c8c8c" }} />
    </span>
  </div>
);

export default SectionHeader;
